import React, { useState } from 'react';
import axios from 'axios';
import WeatherInfo from './WeatherInfo';
import WeatherForecast from './WeatherForecast';
import './Weather.css';

export default function Weather (props){
    let[weatherData, setWeatherData] = useState({ready: false});
    let [city, setCity] = useState(props.defaultCity);

 
    function handleResponse(response){
        setWeatherData({
        ready:true,
        coordinates: response.data.coord,
        temperature: response.data.main.temp,
        wind: response.data.wind.speed,
        date: new Date (response.data.dt * 1000),
        city: response.data.name,
        description: response.data.weather[0].description,
        humidity: response.data.main.humidity,
        icon: response.data.weather[0].icon,
       });
      }

function handleSubmit(event){
event.preventDefault();
search();
//search for the city
}

function handleCityChange(event){
setCity(event.target.value);
}



function search (){
   let apiKey = '5293d8454b519c30f6f6331f38c85b4c';
   let apiUrl= `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
   axios.get(apiUrl).then(handleResponse);
   ;
}



 if (weatherData.ready){
 return(
        <div className='Weather'>
            <form onSubmit={handleSubmit}>
            <div className='row'>
            <div className='col-9'>
            <input 
            type="Search" 
            placeholder='Search for the city'
            className='form-control'
            autoFocus= 'on'
            onChange={handleCityChange}
            />
             </div>
             <div className='col-3'>
            <input type="Submit" 
            value="Search" 
            className='btn btn-primary w-100' />
           
            </div>
                </div>
             </form>
             <WeatherInfo data= {weatherData}/>
             <WeatherForecast coordinates={weatherData.coordinates}/>
             </div>
    );
    } else{

  search()

    return 'Loading...'

    }
}